<template>
	<div>
		<div class="shareSystem_container">
			<p style="margin: 4rem 0;" class="sub_menu_title">系统架构</p>
			<div class="shareSystem_box_t">
				<div class="shareSystem_box_t_list">
					<div class="sys_box">
						<div>
		
							<p class="shareSystem_box_t_title">单位内部使用</p>
							<p class="shareSystem_box_t_msg">单位内部人员内可以编辑部资料、文档资料下载和发布通知公告等</p>
						</div>
						<img class="shareSystem_box_t_img" src="../../../assets/static/images/shebei.png">
					</div>
				</div>
				<div class="shareSystem_box_t_list">
					<div class="sys_box">
						<div>
							<p class="shareSystem_box_t_title">单位外部共享</p>
							<p class="shareSystem_box_t_msg">单位开放实验室闲置的仪器与外界共享仪器，还可以购买耗材交予实验室检验。</p>
						</div>
						<img class="shareSystem_box_t_img" src="../../../assets/static/images/iphone.png">
					</div>
				</div>
			</div>
			<div class="shareSystem_box_b">
				<div class="shareSystem_box_b_list">
					<div class="sys_box_list">
					<p class="shareSystem_box_b_title">后台管理</p>
					<p  class="shareSystem_box_b_msg">后台进行权限分配，电子化管理人员，门禁授权和安全巡查。</p>
					</div>
					<img class="shareSystem_box_b_img"  src="../../../assets/static/images/houtai.png" />
				</div>
				<div class="shareSystem_box_b_list">
					<div class="sys_box_list">
					<p class="shareSystem_box_b_title">数据资源</p>
					<p  class="shareSystem_box_b_msg">后台对相关数据进行记录与统计，例如对人员流动和环境监测进行统计。</p>
					</div>
					<img class="shareSystem_box_b_img"  src="../../../assets/static/images/ziyuan.png" />
				</div>
				<div class="shareSystem_box_b_list">
					<div class="sys_box_list">
					<p class="shareSystem_box_b_title">物联网智能硬件</p>
					<p  class="shareSystem_box_b_msg">关联相关硬件：门禁控制器、视频监控、环境湿度检测器或者气体检测器。</p>
					</div>
					<img class="shareSystem_box_b_img"  src="../../../assets/static/images/wulian.png" />
				</div>
			</div>
		</div>
		<div class="share_container_lage">
			<p style="padding: 5rem 0 3.5rem 0;" class="sub_menu_title">业务模块功能</p>
			<div class="share_container">
				
					<div class="share_box">
						<img src="../../../assets/static/images/bingx.png">
						<div style="padding-top: 3.5rem;">
						<p class="share_box_title">超低温冰箱管控</p>
						<p class="share_box_msg">基于冰箱智能控制器，实现冰箱授权开启，开启时间记录，未关门消息推送。可加装超低温温度探头，实时监测冰箱温度，异常温度即时推送预警信息。</p>
					</div>
					</div>
					<div class="share_box" style="background: linear-gradient(130deg, #2983FF 0%, #0050FF 100%);">
						<img src="../../../assets/static/images/location.png">
						<div style="padding-top: 3.5rem;">
						<p class="share_box_title">场地预约管理</p>
						<p class="share_box_msg">将预约管理和门禁、安全通道等设备有机结合满足实验室对于公共场地使用授权、信息共享，在线预约、鉴权使用的管理需求系统支持时段管制和人数管制，简化预约流程提高场地出入效率，减轻管理人员的负担</p>
						</div>
					</div>
					<div class="share_box_lage">
						<div class="share_box_lage_t">
							<div class="share_box_little">
								<img class="share_box_little_img" src="../../../assets/static/images/water.png">
								<div style="padding-top: 0.5rem;">
								<p class="share_box_little_title">纯水仪管控</p>
								<p class="share_box_little_msg">基于纯水仪智能控制器，实现对纯水仪授权开启且定量或定时使用，计费统计总费用</p>
								</div>
							</div>
							<div style="background: linear-gradient(130deg, #0050FF 0%, #2983FF 100%);" class="share_box_little">
								
								<img  class="share_box_little_img" src="../../../assets/static/images/msg.png">
								<div style="padding-top: 0.5rem;">
								<p class="share_box_little_title">信息发布管理</p>
								<p class="share_box_little_msg">发布通知公告，批量发送短信或邮件，也可提醒公共文档下载相关资源</p>
								</div>
							</div>
						</div>
						<div class="share_box_lage_b">
							<p class="share_box_lage_b_title">科研共享平台</p>
							<p class="share_box_lage_b_msg">对接中科联盟大型科研资源共享平台,与多家医学院和医院合作，平台响应国务院印发《关于国家重大科研基础设施和大型科研仪器向社会开放的意见》涵盖仪器资源发布、仪器预约使用，以及送样检测、技术服务、试剂耗材订购等服务与功能</p>
						</div>
					</div>
				</div>
		</div>
		
	</div>
</template>

<script>
	import { scrollAnimation } from '../../../utils/js/scrollAnimation.js';
	export default {
		created(){
			const currentY = document.documentElement.scrollTop || document.body.scrollTop
			scrollAnimation(currentY, 800)
		},
	}
</script>

<style lang="less" scoped>
	.shareSystem_container{
		
		.shareSystem_box_t{
			display: flex;
			width: 75rem;
			margin: 0 auto;
		}
		.shareSystem_box_t_list{
			width: 36.75rem;
			height: 13.625rem;
			background: #FFFFFF;
			box-shadow: 0 0.3125rem 0.625rem 0 rgba(176,176,176,0.5);
			margin: 0 1rem;
			padding: 2rem 0;
			padding-left: 3rem;
			padding-right: 2rem;
			
		}
		.shareSystem_box_t_title{
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #333333;
		}
		.shareSystem_box_t_msg{
			font-size: 0.875rem;
			width: 18.75rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #333333;
		}
		.sys_box{
			display: flex;
			// justify-content: center;
			// align-items: center;
			flex-direction: column;
		}
		.shareSystem_box_t_img{
			align-self: flex-end;
			margin-top: -4rem;
		}
		.shareSystem_box_b{
			display: flex;
			width: 75rem;
			margin: 0 auto;
			margin-top: 1rem;
			justify-content: space-between;
		}
		.shareSystem_box_b_list{
			position: relative;
			margin: 0 1rem;
			text-align: center;
			}
			.sys_box_list{
				position: absolute;top: 3rem;z-index: 50;
				padding: 0 1.5rem;
			}
			.shareSystem_box_b_msg{
				text-align: left;
				font-size: 0.9375rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #333333;
				line-height: 1.3125rem;
			}
			.shareSystem_box_b_title{
				font-size: 1.25rem;
				font-family: PingFang-SC-Bold, PingFang-SC;
				font-weight: bold;
				color: #333333;
				margin-top: -1rem;
				padding-bottom: 0.5rem;
			}
			.shareSystem_box_b_img{
				transform: scale(1);
				height: 26.5rem;
				width: 24rem;
				margin-left: -0.7rem;
			}
	}
	.share_container_lage{
		height: 56.75rem;
		
background: #F9FAFC;
		.share_container{
			display: flex;
			width: 75rem;
			margin: 0 auto;
		}
		.share_box{
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 18.75rem;
			height: 34.875rem;
			background: linear-gradient(17deg, #7AA6FF 0%, #4A81FD 100%);
			border-radius: 0.1875rem;
			padding: 0 3.1rem;
			padding-top: 1.875rem;
		}
		.share_box_lage{
			width: 37.625rem;
			height: 34.875rem;
			.share_box_lage_t{
				display: flex;
			}
			.share_box_little{
				height: 17.5625rem;
				width: 37.75rem;
				display: flex;
				flex-direction: column;
				align-items: center;
				background: linear-gradient(17deg, #78A5FF 0%, #588CFE 100%);
				border-radius: 0.1875rem;
				padding: 0 2rem;
				padding-top: 1rem;
				
			}
			.share_box_little_img{
				align-self: flex-end;
			}
			.share_box_lage_b{
				width: 37.625rem;
				height: 17.3rem;
				background: linear-gradient(304deg, #BFD4FF 0%, #95B5FF 100%);
				border-radius: 0.1875rem;
			}
		}
		.share_box_title{
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #FFFFFF;
		}
		.share_box_msg{
			font-size: 0.9375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
		}
		.share_box_little_title{
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #FFFFFF;
		}
		.share_box_little_msg{
			font-size: 0.9375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
		}
		.share_box_lage_b{
			display: flex;
			    flex-direction: column;
			    justify-content: flex-end;
			    padding: 1.25rem;
		}
		.share_box_lage_b_title{
			font-size: 1.25rem;
			font-family: PingFang-SC-Bold, PingFang-SC;
			font-weight: bold;
			color: #FFFFFF;
		}
		.share_box_lage_b_msg{
			font-size: 0.9375rem;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #FFFFFF;
			padding-right: 7.8rem;
		}
	}
	
</style>
